import { render, staticRenderFns } from "./detailPayment.vue?vue&type=template&id=9f8c3612&scoped=true"
import script from "./detailPayment.vue?vue&type=script&lang=js"
export * from "./detailPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8c3612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f8c3612')) {
      api.createRecord('9f8c3612', component.options)
    } else {
      api.reload('9f8c3612', component.options)
    }
    module.hot.accept("./detailPayment.vue?vue&type=template&id=9f8c3612&scoped=true", function () {
      api.rerender('9f8c3612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/dispatchAccountsPayable/cmp/detailPayment.vue"
export default component.exports